export default __webpack_public_path__ + "13dc278.png";